import { error, clear } from '../alert/alert.actions';
import { AppDispatch } from '../../../models/redux/dispatch/app.dispatch';
import authFetch from '../../../utils/authFetch';
import { UPDATE_TRAINING, CLEAR_TRAINING, UPDATE_SINGLE_TRAINING } from '../../../constants/training.constants';
import Training from '../../../models/training/TrainingsResponse';
import {
  UpdateTrainingAction,
  ClearTrainingAction,
  UpdateSingleTrainingAction,
} from '../../../models/redux/actions/training.action';
import NETWORK_CONSTANTS from '../../../constants/network.constants';
import SingleTraining from '../../../models/training/SingleTraining';

export function updateTraining(training: Training): UpdateTrainingAction {
  return {
    type: UPDATE_TRAINING,
    training,
  };
}

export function updateSingleTraining(training: SingleTraining): UpdateSingleTrainingAction {
  return {
    type: UPDATE_SINGLE_TRAINING,
    training,
  };
}

export function clearTraining(): ClearTrainingAction {
  return {
    type: CLEAR_TRAINING,
  };
}

const getTrainingAPIcall = (id: string) => {
  return (dispatch: AppDispatch) => {
    const url = `${NETWORK_CONSTANTS.BASE_URL}${NETWORK_CONSTANTS.API_TRAININGS}${id}/`;
    authFetch(dispatch, url, 'GET')
      .then((json) => {
        dispatch(updateTraining(json));
      })
      .catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

const patchTrainingAPIcall = (
  url: string,
  currentPage?: number,
  timeSpent?: number,
  status?: number,
  completed?: string,
) => {
  return (dispatch: AppDispatch) => {
    const body = {
      currentPage,
      timeSpent,
      status,
      dateCompleted: completed,
    };
    authFetch(dispatch, url, 'PATCH', JSON.stringify(body))
      .then((json) => {
        dispatch(updateSingleTraining(json));
      })
      .catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

const postLCAnswerAPIcall = (training?: string, answerIndex?: number) => {
  return (dispatch: AppDispatch) => {
    const url = `${NETWORK_CONSTANTS.BASE_URL}${NETWORK_CONSTANTS.API_KNOWLEDGE_CHECK}/`;
    if (training && answerIndex) {
      const body = {
        training,
        answer: `${NETWORK_CONSTANTS.BASE_URL}${NETWORK_CONSTANTS.API_ANSWERS}/${answerIndex}/`,
      };
      authFetch(dispatch, url, 'POST', JSON.stringify(body)).catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
    }
  };
};

export { getTrainingAPIcall, patchTrainingAPIcall, postLCAnswerAPIcall };
